import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { resetPassword } from '../api/userApi';
import '../StylesCSS/styles.css';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage('');
    setError('');

    // 🔐 validations frontend
    if (!token) {
      setError("Token invalide ou manquant");
      return;
    }

    if (password !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas");
      return;
    }

    if (password.length < 6) {
      setError("Le mot de passe doit contenir au moins 6 caractères");
      return;
    }

    setLoading(true);

    try {
      const response = await resetPassword({
        token,
        newPassword: password
      });

      setMessage(
        response.data?.message ||
        "Mot de passe mis à jour avec succès"
      );

      // ⏳ redirection après succès
      setTimeout(() => {
        navigate('/login');
      }, 2000);

    } catch (error) {
      const backend = error.response?.data;

      setError(
        backend?.message ||
        backend?.error ||
        "Erreur lors de la réinitialisation du mot de passe"
      );

    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="reset-page">
      <section className="reset-card">
        <header className="reset-header">
          <span className="reset-brand">AL-BAWSALA</span>
          <h1>Réinitialiser le mot de passe</h1>
          <p>Choisissez un nouveau mot de passe pour votre compte.</p>
        </header>

        <div className="reset-body">
          {!token && (
            <div className="status-alert error" role="alert">
              Lien invalide ou token manquant.
            </div>
          )}
          {message && <div className="status-alert success" role="status">{message}</div>}
          {error && <div className="status-alert error" role="alert">{error}</div>}

          <form onSubmit={handleSubmit} className="reset-form">
            <div className="reset-field">
              <label htmlFor="new-password">Nouveau mot de passe</label>
              <input
                className="form-control"
                id="new-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="6 caractères minimum"
                autoComplete="new-password"
                minLength={6}
                required
              />
            </div>

            <div className="reset-field">
              <label htmlFor="confirm-password">Confirmer le mot de passe</label>
              <input
                className="form-control"
                id="confirm-password"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirmez votre mot de passe"
                autoComplete="new-password"
                minLength={6}
                required
              />
            </div>

            <button
              className="btn btn-primary reset-button"
              type="submit"
              disabled={loading || !token}
            >
              {loading ? 'Mise à jour...' : 'Enregistrer le nouveau mot de passe'}
            </button>
          </form>
        </div>

        <footer className="reset-footer">
          <button
            className="btn btn-link"
            type="button"
            onClick={() => navigate('/login')}
          >
            Retour à la connexion
          </button>
        </footer>
      </section>
    </main>
  );
};

export default ResetPassword;